import _regeneratorRuntime from "/home/fabienjuif/work/k-mille2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/fabienjuif/work/k-mille2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _toConsumableArray from "/home/fabienjuif/work/k-mille2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "/home/fabienjuif/work/k-mille2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/home/fabienjuif/work/k-mille2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/home/fabienjuif/work/k-mille2/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import gql from 'graphql-tag';
import innerOptions from './options';
/* eslint-env browser */

var dispatchFactory = function dispatchFactory(store) {
  return function (_ref) {
    var operationName = _ref.operationName,
        selections = _ref.selections;
    return function (event, _ref2) {
      var selection = _ref2.selection,
          payload = _objectWithoutProperties(_ref2, ["selection"]);

      var name = selection || operationName || selections.join(',');

      var action = _objectSpread({
        type: "@@graphql/".concat(name, ">").concat(event)
      }, payload);

      if (selection) action.selection = selection;
      store.dispatch(action);
    };
  };
};

var getEndpoint = function getEndpoint(driverOptions) {
  switch (typeof driverOptions) {
    case 'undefined':
      return '/graphql';

    case 'string':
      return driverOptions;

    default:
      return driverOptions.endpoint;
  }
};

var getDriver = function getDriver(driverOptions) {
  return function (store) {
    var endpoint = getEndpoint(driverOptions);
    var ownFetch = driverOptions && driverOptions.fetch || (global || window).fetch;

    if (!ownFetch) {
      throw new Error('[k-ramel/driver-graphql] fetch is mandatory to use this driver');
    }

    var setAuthorization = function setAuthorization(authorization) {
      var headers = {
        Authorization: authorization
      };
      innerOptions.set({
        headers: headers
      });

      if (!authorization) {
        delete innerOptions.headers.Authorization;
      }
    };

    var parseGql = function parseGql(operation) {
      return function (string, inputs) {
        var _ref4;

        // rework query to add 'mutation' keyword if it's forget
        var requests = string.trim();
        if (operation === 'query' && !requests.startsWith('{')) requests = "{ ".concat(string, " }");
        if (!requests.includes(operation)) requests = "".concat(operation, " ").concat(requests); // parse query with gql-tags

        var _gql = gql(requests),
            definitions = _gql.definitions,
            loc = _gql.loc; // TODO: at this time, this driver works with only one layer of definition


        var _definitions = _slicedToArray(definitions, 1),
            definition = _definitions[0];

        var variables = definition.variableDefinitions.reduce(function (acc, _ref3) {
          var variable = _ref3.variable;
          return _objectSpread({}, acc, _defineProperty({}, variable.name.value, inputs[variable.name.value]));
        }, {});

        var selections = (_ref4 = []).concat.apply(_ref4, _toConsumableArray(definitions.map(function (_ref5) {
          var selectionSet = _ref5.selectionSet;
          return selectionSet.selections.map(function (selection) {
            return selection.alias && selection.alias.value || selection.name.value;
          });
        })));

        var operationName = definition.name && definition.name.value || undefined;
        return {
          operationName: operationName,
          variables: variables,
          query: loc.source.body,
          selections: selections
        };
      };
    };

    var execute =
    /*#__PURE__*/
    function () {
      var _ref6 = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(query) {
        var dispatch, raw, status, _errors, res, _ref7, data, errors, selectionsOnError;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                dispatch = dispatchFactory(store)(query); // dispatch one event by selection wanted

                dispatch('STARTED', {
                  query: query
                });
                _context.next = 4;
                return ownFetch(endpoint, innerOptions.get({
                  body: JSON.stringify(query)
                }));

              case 4:
                raw = _context.sent;
                // in case of HTTP error, we try to deserialize the response
                // but it could fail
                status = raw.status;

                if (!(status >= 400 || status < 200)) {
                  _context.next = 19;
                  break;
                }

                _context.prev = 7;
                _context.next = 10;
                return raw.json();

              case 10:
                res = _context.sent;
                _errors = res.errors; // eslint-disable-line prefer-destructuring

                _context.next = 17;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](7);
                _errors = _context.t0;

              case 17:
                dispatch('FAILED', {
                  payload: _errors,
                  status: status,
                  selections: query.selections
                });
                return _context.abrupt("return", {
                  errors: _errors
                });

              case 19:
                _context.next = 21;
                return raw.json();

              case 21:
                _ref7 = _context.sent;
                data = _ref7.data;
                errors = _ref7.errors;
                selectionsOnError = [];

                if (errors && errors.length > 0) {
                  errors.forEach(function (error) {
                    selectionsOnError.push(error.path[0]);
                    dispatch('FAILED', {
                      payload: error,
                      selection: error.path[0],
                      status: status
                    });
                  });
                }

                query.selections.forEach(function (selection) {
                  // dispatch only selections without errors
                  if (!selectionsOnError.includes(selection)) {
                    dispatch('ENDED', {
                      payload: data[selection],
                      selection: selection,
                      status: status
                    });
                  }
                });
                dispatch('DONE', {
                  query: query
                });
                return _context.abrupt("return", {
                  data: data,
                  errors: errors
                });

              case 29:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 14]]);
      }));

      return function execute(_x) {
        return _ref6.apply(this, arguments);
      };
    }();

    var request = function request(operation) {
      return (
        /*#__PURE__*/
        function () {
          var _ref8 = _asyncToGenerator(
          /*#__PURE__*/
          _regeneratorRuntime.mark(function _callee2(string, variables) {
            var query;
            return _regeneratorRuntime.wrap(function _callee2$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    query = parseGql(operation)(string, variables);
                    return _context2.abrupt("return", execute(query));

                  case 2:
                  case "end":
                    return _context2.stop();
                }
              }
            }, _callee2);
          }));

          return function (_x2, _x3) {
            return _ref8.apply(this, arguments);
          };
        }()
      );
    };

    return {
      query: request('query'),
      mutation: request('mutation'),
      setAuthorization: setAuthorization,
      clearAuthorization: function clearAuthorization() {
        return setAuthorization();
      }
    };
  };
};

export default (function (options) {
  return {
    getDriver: getDriver(options)
  };
});